<template>
  <el-menu
    :default-active="active"
    router
    mode="horizontal"
    background-color="white"
    text-color="#222"
    active-text-color="red"
    style="min-width: 1300px">
    <el-menu-item v-for="(item,i) in navList" :key="i" :index="item.name">
      {{ item.navItem }}
    </el-menu-item>
    <div style="float: right;padding: 20px;letter-spacing: 20px;">
      <router-link to="login">
            <el-button type="success">登录</el-button>
      </router-link>
      <router-link to="register">
            <el-button type="primary">注册</el-button>
      </router-link>
    </div>
  </el-menu>
</template>

<!-- https://blog.csdn.net/qw_cui/article/details/123998788 -->

<script>
export default {
  name: 'NavMenu',
  data () {
    return {
      active: '/index',
      navList: [
        {name: '/index', navItem: '首页'},
        {name: '/desc', navItem: '业务描述'},
        {name: '/product', navItem: '开发产品'},
        {name: '/partner', navItem: '合作伙伴'}
      ]
    }
  },
  mounted(){
    this.active = this.$route.path
  }
}
</script>

<style scoped>
a{
  text-decoration: none;
}

span {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/front/common/Header.vue